import { css } from '@emotion/react'
import { rem } from '@groovehq/internal-design-system/lib/util'

const imageBox = css`
  width: ${rem(120)};
  margin: ${rem(16)} auto;
  & > img {
    width: 100%;
  }
`

const textArea = css`
  max-width: 100%;
`

const agentTypeDescription = css`
  display: block;
  margin: 4px 0px 10px 0;
`

const upgradeButton = css`
  margin-left: 4px;
`
const agentDescriptionLong = css`
  margin-top: 8px;
`

const annualComparison = theme => css`
  display: flex;
  flex-direction: column;
  gap: ${rem(6)};
  margin-top: ${rem(16)};
  padding: ${rem(14)} ${rem(16)};
  border: 1px solid ${theme.color.info['100']};
  border-radius: ${rem(10)};
  background: ${theme.color.info['50']};
  color: ${theme.color.monochrome.black};
  font-size: ${rem(13)};
  line-height: 1.5;
  overflow-wrap: anywhere;
  p {
    margin: 0;
  }
  strong {
    font-weight: ${theme.fontWeight.bold};
    color: ${theme.color.monochrome.black};
  }
`

const annualSaving = theme => css`
  color: ${theme.color.monochrome.dark};
`

const annualLink = theme => css`
  box-sizing: border-box;
  min-width: 44px;
  min-height: 44px;
  max-width: 100%;
  margin: ${rem(-12)} 0;
  padding: ${rem(12)} 0;
  border: 0;
  background: transparent;
  color: ${theme.color.info['500']};
  font: inherit;
  font-weight: ${theme.fontWeight.semibold};
  text-align: left;
  text-decoration: underline;
  cursor: pointer;
  &:focus-visible {
    outline: 2px solid ${theme.color.info['500']};
    outline-offset: 2px;
  }
`

export const styles = {
  annualComparison,
  annualSaving,
  annualLink,
  imageBox,
  textArea,
  agentTypeDescription,
  upgradeButton,
  agentDescriptionLong,
}
